import styled, { css } from "styled-components"
import { dark } from "styles/theme"
import { Link } from "styles/GlobalStyle"
import { Center } from "styles/GlobalCss"
import { styled as muiStyled } from '@mui/material/styles';
import { Box } from "@mui/material";

export const LoginStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    color: dark,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    '.forgot-username-or-password': {
        display: "flex",
        justifyContent: "flex-start",
        padding: "15px 0px"
    },
    '.register-btn': {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    '.new-user': {
        width: 370,
        fontSize: 18,
        fontWeight: 700
    }
}));

export const WrapAuth = styled.div`
display: flex;
height: 100%;
`

export const Logo = styled.div`
width:70px;
height:70px;
position: absolute;
top: 10px;
left: 25px;
`

export const InstructionItem = styled.li`
color: rgba(0, 0, 0, 0.50);
font-size: 17px;
`

export const Instructions = styled.ul`
margin-block-start: inherit;
display: flex;
flex-direction: column;
row-gap: 6px;
`

export const FormContent = styled.div`
width:400px;

`

export const ForgotUserNameOrPassword = styled.div`
height:50px;
${Center};
`

export const RegisterLink = styled(Link)`
    position: relative;
    top: 100px;
`

export const WrapLogo = styled.div`
width: 208.77px;
height: 156.28px;
`

export const Left = styled.div`
background:${dark};
width:40%;
display: flex;
align-items: center;
justify-content: center;
`

export const Right = styled.div`
width:60%;
display: flex;
align-items: center;
justify-content: center;
`

export const WrapForm = styled.div`
display:flex;
overflow-y:auto;
align-items:center;
justify-content:center;
height:85%;
position: relative;
min-width:800px;
column-gap:50px;

@media only screen and (min-width: 1900px) {
column-gap:100px;
}

@media only screen and (min-height: 550px) {
top: 50px;
}
`

export const WrapFormFields = styled.div`
width:430px;
`

export const WrapCartoon = styled.div`
display:flex;
justify-content:start;
`

export const CartoonItem = styled.div`
width: ${props => props.height || "350"}px;
height: ${props => props.height || "350"}px;
`
